import { Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { EntityCodes, DeviceAllocationTypes, DeviceTypes } from '../../Models/EnumModels';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StaffDevice, AddDeviceRequest, ShiftSetUpModel } from '../../Models/RequestModels';
import { ShiftSetUpService } from '../../Services/ShiftSetUpService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from "lodash";
import { GenericMaster } from '../../Models/GlobalEntities';
import { ShiftSetUp } from '../../Components/ShiftSetUp/ShiftSetUp';

@Component({
    selector: 'DeviceDetail',
    templateUrl: './DeviceDetail.html',
})

export class DeviceDetail extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @Input() AllDeviceData: Array<StaffDevice>;
    ModalRef: NgbModalRef;
    Model: any;
    PrimaryDeviceData: Array<StaffDevice>;
    BackupDeviceData: Array<StaffDevice>;
    ToggleEnable: boolean;
    AllowedDevices: Array<GenericMaster>;
    ShowBackupDevice: boolean;
    DeletedDevices: Array<StaffDevice>;
    DisableModalOpenEvent: boolean = false;

    @Output() DeviceUpdated: EventEmitter<number> = new EventEmitter<number>();
    //@Output() DeviceUpdated: EventEmitter<number> = new EventEmitter<number>();
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, protected shiftSetUpService: ShiftSetUpService, public shiftSetUp: ShiftSetUp) {
        super(translate, toastr, route, router, masterService);

    }
    ngOnInit(): void {
        this.Model = {};
        this.Model.StaffId = 0;
        this.Model.StaffName = "";
        
    }

    Open(StaffId: number, data: ShiftSetUpModel): void {
        if (this.DisableModalOpenEvent) return;
        //let modalClass = this.masterService.CheckBrowser() == 'ie' ? 'modalZIndexIE' : '';
        //let modalbackdropClass = this.masterService.CheckBrowser() == 'ie' ? 'modalZIndexIE' : '';
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        //this.masterService.SetModalZ_Index();
        this.DisableModalOpenEvent = true;

        this.Model = {};
        this.Model.PropertyId = data.PropertyId;
        this.Model.DeptId = data.DeptId;
        this.DeletedDevices = [];
        this.AllowedDevices = this.masterService.GetAllDeviceType(data.PropertyId);
        this.Model.StaffId = StaffId;        
        this.PrimaryDeviceData = this.AllDeviceData.filter
            (obj => obj.StaffId == StaffId && obj.DeviceAllocationType == DeviceAllocationTypes.Primary && this.AllowedDevices.findIndex(item => item.Id == obj.DeviceType) >= 0);
        if (this.PrimaryDeviceData.length > 0 && this.PrimaryDeviceData.findIndex(obj => obj.DeviceType == DeviceTypes.MobileApp && obj.IsEnabled == true) >= 0) {
            this.ShowBackupDevice = true;
        }
        else
            this.ShowBackupDevice = false;
        this.BackupDeviceData = this.AllDeviceData.filter
            (obj => obj.StaffId == StaffId && obj.DeviceAllocationType == DeviceAllocationTypes.Backup && this.AllowedDevices.findIndex(item => item.Id == obj.DeviceType) >= 0);

        if (!this.PrimaryDeviceData) {
            this.PrimaryDeviceData = [];
        }
        if (!this.BackupDeviceData) {
            this.BackupDeviceData = [];
        }
        //else this.BackupDeviceData = [];
        
        //if (this.PrimaryDeviceData.length == 0) {
        //    this.PrimaryDeviceData = [];
        //    //this.PrimaryDeviceData.StaffId = staffId;
        //}
        //if (this.BackupDeviceData.length == 0) {
        //    this.BackupDeviceData = [];
        //    //this.BackupDeviceData.StaffId = staffId;
        //}
        this.AllEnabled();
        this.Model.StaffName = this.masterService.MasterData_GetMutli(this.Model.PropertyId, this.Model.StaffId, EntityCodes.Staff, "")
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    DeleteDevice(Device: StaffDevice): void {
        if (Device.DeviceAllocationType == DeviceAllocationTypes.Backup) {
            //this.BackupDeviceData = this.BackupDeviceData.filter((row) => {
            //    return row.DeviceId != data.DeviceId;
            //})
            let index = this.BackupDeviceData.findIndex(obj => obj.DeviceType == Device.DeviceType);
            this.BackupDeviceData.splice(index, 1);

        }
        else {
            //this.DeviceData = this.DeviceData.filter((row) => {
            //    return row.DeviceId != data.DeviceId;
            //})
            let index = this.PrimaryDeviceData.findIndex(obj => obj.DeviceType == Device.DeviceType);
            if (this.PrimaryDeviceData[index].DeviceType == DeviceTypes.MobileApp) {
                this.ShowBackupDevice = false;
                this.BackupDeviceData.forEach(item => {
                    this.DeletedDevices.push(item);
                })
                this.BackupDeviceData = [];
            }
            this.PrimaryDeviceData.splice(index, 1);
        }
        if (Device.DeviceType) {
            this.DeletedDevices.push(Device);
        }
        if (this.PrimaryDeviceData.length > 0 && this.PrimaryDeviceData.findIndex(obj => obj.DeviceType == DeviceTypes.MobileApp && obj.IsEnabled == true) >= 0) {
            this.ShowBackupDevice = true;
        }
        else
            this.ShowBackupDevice = false;

    }
   
    SaveMapping(): void {
        let AddDeviceRequestModel: AddDeviceRequest = new AddDeviceRequest();
        AddDeviceRequestModel.PropertyId = this.Model.PropertyId;
        AddDeviceRequestModel.DeptId = this.Model.DeptId;
        AddDeviceRequestModel.StaffId = this.Model.StaffId;
        AddDeviceRequestModel.ListDevices = _.concat(this.PrimaryDeviceData, this.BackupDeviceData);
        this.shiftSetUpService.AddDevice(AddDeviceRequestModel).then(data => {
            if (data.HasError) {
                this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error');
            }
            if (data.Result) {
                this.DeletedDevices.forEach(item => {
                    let index = this.AllDeviceData.findIndex(obj => obj.StaffId == item.StaffId && obj.DeviceType == item.DeviceType);
                    if (index >= 0) {
                        this.AllDeviceData.splice(index, 1);
                    }
                });
                data.Result.forEach(item => {
                    let index = this.AllDeviceData.findIndex(obj => obj.StaffId == item.StaffId && obj.DeviceType == item.DeviceType && obj.DeviceAllocationType == item.DeviceAllocationType);
                    if (index >= 0) {
                        this.AllDeviceData.splice(index, 1);
                    }
                    this.AllDeviceData.push(item);
                })
                this.shiftSetUp.ShiftResponseModel.ListStaffDevices = _.cloneDeep(this.AllDeviceData);
                this.DeviceUpdated.emit(this.Model.StaffId);
            }
        })
        this.ModalRef.close();
    }

    AllEnabled(): void {
        let index = this.PrimaryDeviceData.findIndex(obj => obj.IsEnabled == false);
        if (index >= 0) this.ToggleEnable = true;
        else this.ToggleEnable = false;

        if (this.PrimaryDeviceData.length > 0 && this.PrimaryDeviceData.findIndex(obj => obj.DeviceType == DeviceTypes.MobileApp && obj.IsEnabled == true) >= 0) {
            this.ShowBackupDevice = true;
        }
        else
            this.ShowBackupDevice = false;
    }
    EnableAllDevices(): void {
        this.PrimaryDeviceData.forEach(obj => {
            obj.IsEnabled = true;
            if (obj.DeviceType == DeviceTypes.MobileApp && obj.IsEnabled == true) {
                this.ShowBackupDevice = true;
            }
        });
        this.ToggleEnable = false;
    }
    DisableAllDevices(): void {
        this.PrimaryDeviceData.forEach(obj => {
            obj.IsEnabled = false;
            
        });
        this.ShowBackupDevice = false;
        this.ToggleEnable = true;
    }
}
